import "./DashboardNormal.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api_url } from "../../constant/constant";
import { Button } from "react-bootstrap";
import { showToast } from "../../Components/ShowToast/ToastNotification";

const DashboardNormal = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [dashboardMessage, setDashboardMessage] = useState("");
  const [score, setScore] = useState(null);

  const [PolicyData, setPolicyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [PolicyTitle, setPolicyTitle] = useState("");
  const [showPolicy, setShowPolicy] = useState(true);

  // ✅ All campaigns
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    const savedScore = localStorage.getItem("examScore");

    if (savedScore) {
      setScore(savedScore);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("userToken");

        const response = await fetch(`${api_url}/user/dashboard`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();

        console.log("API Response:", result);

        if (result.status === "success") {
          setDashboardMessage(result.message || "");

          /** =========================
           * ✅ Compliance Policies
           ========================== */
          if (
            Array.isArray(result.compliance) &&
            result.compliance.length > 0
          ) {
            const complianceCampaign = result.compliance[0];

            if (
              Array.isArray(complianceCampaign.policies) &&
              complianceCampaign.policies.length > 0
            ) {
              const policy = complianceCampaign.policies[0];

              if (policy.is_accepted) {
                setShowPolicy(false);
              } else {
                setPolicyData(policy);
                setPolicyTitle(policy.title || "");
                setShowPolicy(true);
              }
            } else {
              setShowPolicy(false);
            }
          } else {
            setShowPolicy(false);
          }

          /** =========================
           * ✅ Learning + Surveys
           ========================== */
          let allCampaigns = [];

          // Learning campaigns
          if (
            Array.isArray(result.learning) &&
            result.learning.length > 0
          ) {
            allCampaigns = [...allCampaigns, ...result.learning];
          }

          // Compliance surveys
          if (
            Array.isArray(result.compliance) &&
            result.compliance.length > 0
          ) {
            allCampaigns = [...allCampaigns, ...result.compliance];
          }

          setCampaigns(allCampaigns);
        }
      } catch (err) {
        console.error("Fetch error:", err);

        showToast(
          t("somethingwentwrongpleaserefresh"),
          "error"
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  /** =========================
   * ✅ Lesson Click
   ========================== */
  const handleLessonClick = (lesson, campaign) => {
    navigate("/LessonVideos", {
      state: {
        lesson: lesson,
        Videoseek: campaign.video_seek,
        assessments: lesson?.lesson_quiz_summary,
      },
    });
  };

  /** =========================
   * ✅ Policy Click
   ========================== */
  const handlepolicyClick = () => {
    navigate("/UserPolicies", {
      state: { PolicyData: PolicyData },
    });
  };

  /** =========================
   * ✅ Survey Click
   ========================== */
  const handleSurveyClick = (survey, campaign) => {
    navigate("/SurveyPage", {
      state: {
        survey: survey,
        campaign_id: campaign.campaign_id,
      },
    });
  };

  return (
    <div className="dashboard-container p-4 mb-4">
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div
            className="spinner-border text-primary"
            role="status"
          >
            <span className="visually-hidden">
              {t("Loading")}...
            </span>
          </div>
        </div>
      ) : (
        <>
          {/* ✅ Empty State */}
          {!showPolicy && campaigns.length === 0 ? (
            <div className="text-center mt-5">
              <h3>
                {dashboardMessage ||
                  t("Welcome to the dashboard!")}
              </h3>
            </div>
          ) : (
            <>
              {/* =========================
                  ✅ Policy Section
              ========================== */}
              {showPolicy && (
                <div className="mb-4">
                  <h3 className="text-bluelightsenselarge">
                    {t("AssignedPolicy")}
                  </h3>

                  <p>{t("acceptpolicytext")}</p>

                  <div
                    className="col-xl-8 col-md-12 mb-12 lesson-cards"
                    onClick={handlepolicyClick}
                  >
                    <h5 style={{ padding: 5 }}>
                      {PolicyTitle}
                    </h5>

                    <i className="bi bi-box-arrow-right me-2 text-bluelightsense"></i>
                  </div>
                </div>
              )}

              {/* =========================
                  ✅ Campaigns Section
              ========================== */}
              <div className="row mt-4">
                {campaigns.length > 0 ? (
                  campaigns.map((campaign, idx) => (
                    <div
                      key={idx}
                      className="col-xl-8 col-md-12 mb-12"
                    >
                      <h3
                        className={`text-bluelightsenselarge ${
                          i18n.language === "ar"
                            ? "arabic-title"
                            : ""
                        }`}
                      >
                        {campaign.campaign_name ||
                          campaign.title ||
                          "Campaign"}
                      </h3>

                      <div className="lessons-container row">
                        {/* =========================
                            ✅ Videos
                        ========================== */}
                        {Array.isArray(
                          campaign.videos_with_quizzes
                        ) &&
                          campaign.videos_with_quizzes.map(
                            (lesson, index) => (
                              <div
                                key={index}
                                className="col-md-4 d-flex justify-content-center align-items-stretch mb-4"
                                onClick={() =>
                                  handleLessonClick(
                                    lesson,
                                    campaign
                                  )
                                }
                              >
                                <div className="lesson-card text-center shadow-sm rounded-4 p-4">
                                  <div className="lesson-icon mb-3">
                                    <img
                                      src="/images/video.png"
                                      alt="Video Icon"
                                      className="img-fluid"
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                      }}
                                    />
                                  </div>

                                  <h6 className="fw-semibold mb-3">
                                    {lesson.lesson_title}
                                  </h6>

                                  <p className="lesson-status mb-0">
                                    {lesson.watched ? (
                                      <>
                                        <i className="bi bi-eye me-1"></i>
                                        {t("watched")}
                                      </>
                                    ) : (
                                      <>
                                        <i className="bi bi-eye-slash me-1"></i>
                                        {t("Unwatched")}
                                      </>
                                    )}
                                  </p>
                                </div>
                              </div>
                            )
                          )}

                        {/* =========================
                            ✅ Surveys
                        ========================== */}
                        {Array.isArray(campaign.surveys) &&
                          campaign.surveys.map(
                            (survey, index) => (
                              <div
                                key={index}
                                className="col-md-4 d-flex justify-content-center align-items-stretch mb-4"
                                onClick={() =>
                                  handleSurveyClick(
                                    survey,
                                    campaign
                                  )
                                }
                              >
                                <div className="lesson-card text-center shadow-sm rounded-4 p-4">
                                  <div className="lesson-icon mb-3">
                                    <img
                                      src="/images/survey.png"
                                      alt="Survey Icon"
                                      className="img-fluid"
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                      }}
                                    />
                                  </div>

                                  <h6 className="fw-semibold mb-3">
                                    {survey.title}
                                  </h6>

                                  <p className="lesson-status mb-0">
                                    {survey.is_complete ? (
                                      <>
                                        <i className="bi bi-check-circle me-1"></i>
                                        Completed
                                      </>
                                    ) : (
                                      <>
                                        <i className="bi bi-pencil-square me-1"></i>
                                        Pending
                                      </>
                                    )}
                                  </p>
                                </div>
                              </div>
                            )
                          )}

                        {/* =========================
                            ✅ No Data
                        ========================== */}
                        {(!campaign.videos_with_quizzes ||
                          campaign.videos_with_quizzes
                            .length === 0) &&
                          (!campaign.surveys ||
                            campaign.surveys.length ===
                              0) && (
                            <p>
                              {t("Nolessonsavailable")}
                            </p>
                          )}
                      </div>

                      {/* =========================
                          ✅ Exam Section
                      ========================== */}
                      {campaign.can_start_exam &&
                        !campaign?.exam_taken && (
                          <div className="exam-card p-3 border rounded shadow-sm mt-3">
                            <h5 className="mb-0">
                              <i className="bi bi-clipboard-check fs-4 me-2"></i>
                              {t("Exam")}
                            </h5>

                            <div className="d-flex justify-content-center align-items-center flex-column">
                              <Button
                                style={{
                                  width: 200,
                                  marginTop: 20,
                                }}
                                onClick={() =>
                                  navigate("/CampaignExam", {
                                    state: {
                                      campaign_id:
                                        campaign.campaign_id,
                                    },
                                  })
                                }
                                className="btn btn-outline-primary btn-sm"
                              >
                                {t("Start")}
                              </Button>

                              {score !== null && (
                                <p className="mt-3 fw-bold text-success">
                                  {t("Your Score")}: {score}
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  ))
                ) : (
                  <p>{t("Nolessonsavailable")}</p>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default DashboardNormal; 